import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useOAuth2Context } from './contexts/OAuth2Context';

export default function AuthCallback() {
    const navigate = useNavigate();
    const { userManager } = useOAuth2Context();

    useEffect(() => {
        let isHandled = false;

        if (!isHandled) {
            userManager.signinRedirectCallback()
                .then(() => {
                    isHandled = true;
                    window.location.replace('/');
                })
                .catch(err => console.error(err));
        }

        // opzionale: cleanup se serve
        return () => {
            isHandled = true;
        };
    }, []);

    return <div>Accesso in corso...</div>;
}